import { jsx as _jsx } from "react/jsx-runtime";
const SvgTick = (props) => (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: _jsx("path", { d: "m5.5 14 4 3 9-11", stroke: "#98FF7E" }) }));
export default SvgTick;
